<script setup>
import { computed } from 'vue';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
});

const messageBody = computed(() => props.node.config?.body || '');
</script>

<template>
  <div class="bg-white px-3 py-2.5">
    <div
      class="text-[10px] font-semibold uppercase tracking-wide text-n-slate-10"
    >
      {{ node.type }}
    </div>
    <div
      class="mt-1.5 whitespace-pre-wrap text-[12px] leading-5 text-n-slate-12"
    >
      {{ messageBody }}
    </div>
  </div>
</template>
